import { getHelpUrl } from "../../utility/header.utility"
import NotificationAction from "./NotificationAction/NotificationAction"
import SearchActions from "./ActionButtons/SearchActions"
import HelpAction from "./ActionButtons/HelpAction"
import ProfileAction from "./ProfileAction/ProfileAction"
import AIAction from "./ActionButtons/AIAction"
import {coreStore, subscriptionManager} from "@forcepoint/platform-coreui";
import {calcScopePermission} from "@forcepoint/platform-utilityui"
import { useEffect, useState } from "react"

const QuickActionButtons = ({
    setCurrentDropdown,
    currentDropdown,
    stateData
}) => {
    // const settingsMenuList = stateData?.settingsMenu
    const helpUrl = getHelpUrl(stateData)
    const activeApp = stateData?.activeApp    
    
    const [isAIEnabled, setIsAIEnabled] = useState(coreStore.getState().aiPanel?.isEnabled || false)
    const userInfo = stateData?.userInfo
    const aiScope = userInfo && calcScopePermission("ai-chat")
    useEffect(()=>{
        const unsubscribe = subscriptionManager.subscribe(
            coreStore,
            state => state.aiPanel?.isEnabled,
            (isEnabled) => setIsAIEnabled(isEnabled)
        );
        return () => {
            unsubscribe();
        };
    },[])
    return (
        <ul className="shell-menu">
            {isAIEnabled && aiScope.add && <>
                <AIAction/>
                <VerticalLine/>
            </>}
            <SearchActions activeApp={activeApp} />
            {/* <SettingsActions settingsMenuList={settingsMenuList} /> */}
            <HelpAction helpUrl={helpUrl} />
            { helpUrl && (
                <VerticalLine/>
            )}
            <NotificationAction
                stateData={stateData}
                setCurrentDropdown={setCurrentDropdown}
                currentDropdown={currentDropdown}
            />
            <ProfileAction
                stateData={stateData}
                setCurrentDropdown={setCurrentDropdown}
                currentDropdown={currentDropdown}
            />
        </ul>
    )
}

export default QuickActionButtons

const VerticalLine = ()=>{
    return <li className="vertical-line">
                <a
                    onClick={(e) => e.preventDefault()}
                    onKeyDown={() => { }}
                    aria-label="Placeholder for action"
                >
                    {/* Link does not need visible content but is accessible */}
                </a>
            </li>
}